import React, { useRef, useState, useEffect } from 'react';
import AnimatedPieChart from './AnimatedPieChart';
import { Box, Typography } from '@mui/joy';

const ResponsivePieChart = (props) => {
  const { data, height = 300 } = props;
  const containerRef = useRef(null);
  const [width, setWidth] = useState(300); // default fallback

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.offsetWidth);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Show 'No data available' if data is empty or not an array
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div ref={containerRef} style={{ width: '100%' }}>
        <Box sx={{ 
          width,
          height,
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          borderRadius: 2,
          textAlign: 'center'
        }}>
          <Typography level="body-sm" color="neutral" sx={{ textAlign: 'center' }}>
            No data available
          </Typography>
        </Box>
      </div>
    );
  }

  // Only render chart when width is valid
  if (width < 50) {
    return <div ref={containerRef} style={{ width: '100%', height }} />;
  }

  return (
    <div ref={containerRef} style={{ width: '100%' }}>
      <AnimatedPieChart {...props} width={width} />
    </div>
  );
};

export default ResponsivePieChart; 